interface BoundItem {
  events: string[];
  fn: any;
  scope: any;
}

const bound: BoundItem[] = [];

export class EventHandler {

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  public static bind(evt: string, fn: any, scope: any = window): void {
    bound.push({
      events: evt.split(' '),
      fn,
      scope,
    });
  }

  public static trigger(evt: string, ...args: any[]): void {
    let target: BoundItem;
    for (let i = 0; i < bound.length; i++) {
      target = bound[i];

      if (target.events.indexOf(evt) > -1) {
        target.fn.apply(target.scope, args);
      }
    }
  }
}
